import { render, staticRenderFns } from "./promptBox.vue?vue&type=template&id=54fa0e67&scoped=true"
import script from "./promptBox.vue?vue&type=script&lang=js"
export * from "./promptBox.vue?vue&type=script&lang=js"
import style0 from "./promptBox.vue?vue&type=style&index=0&id=54fa0e67&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fa0e67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54fa0e67')) {
      api.createRecord('54fa0e67', component.options)
    } else {
      api.reload('54fa0e67', component.options)
    }
    module.hot.accept("./promptBox.vue?vue&type=template&id=54fa0e67&scoped=true", function () {
      api.rerender('54fa0e67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/promptBox.vue"
export default component.exports